<template>
  <div class="md-layout">
    <div
      v-if="isProgress"
      class="md-layout-item md-size-100 md-medium-size-100 bar-progress"
    >
      <md-progress-bar
        class="bar-progress"
        md-mode="indeterminate"
      ></md-progress-bar>
    </div>
    <div class="md-layout-item md-size-60 mx-auto">
      <md-card>
        <md-card-header>
          <div class="card-icon">
            <md-icon>add_alert</md-icon>
          </div>
          <h4 class="title">Settings</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="settings">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="#">{{ item.id }}</md-table-cell>
              <md-table-cell md-label="Name">{{ item.name }}</md-table-cell>
              <md-table-cell md-label="Value">{{ item.value }}</md-table-cell>
              <md-table-cell md-label="Type">{{ item.type }}</md-table-cell>
              <md-table-cell md-label="Active">
                <md-checkbox v-model="item.active" disabled></md-checkbox>
              </md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button
                  title="edit user"
                  class="md-just-icon md-button md-just-icon md-theme-default md-warning"
                  @click="showDialogEditConfigurations(item)"
                >
                  <md-icon class="md-icon md-icon-font md-theme-default"
                    >edit</md-icon
                  >
                </md-button>
                <!-- <md-button title="remove user" @click="alertNotication(item.id)" class="md-just-icon md-button md-just-icon md-theme-default md-danger">
                                                        <md-icon>remove_circle</md-icon>
                                                 </md-button>
                                                 <md-button v-if="!item.approved_at" title="enable user" @click="statusUser(item.id)" class="md-just-icon md-button md-just-icon md-theme-default md-primary">
                                                        <md-icon class="md-icon md-icon-font md-theme-default">info</md-icon>
                                                 </md-button>
                                                 <md-button v-else title="user enabled" class="md-just-icon md-button md-just-icon md-theme-default md-default">
                                                        <md-icon class="md-icon md-icon-font md-theme-default">check_circle</md-icon>
                                                 </md-button> -->
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
    <template>
      <md-dialog class="md-dialog" :md-active.sync="showDialogEdit">
        <md-dialog-title>Update Setting</md-dialog-title>
        <md-card-content>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-50">
                <md-field>
                  <label>Name</label>
                  <md-input
                    ref="name"
                    v-model="edit.name"
                    type="text"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-50">
                <md-field>
                  <label>Value</label>
                  <md-input
                    ref="value"
                    v-model="edit.value"
                    type="text"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-50">
                <md-field>
                  <label>Type</label>
                  <md-input
                    ref="type"
                    v-model="edit.type"
                    type="text"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-50">
                <label>Active</label>
                <md-checkbox v-model="active" @change="checkmy()"></md-checkbox>
              </div>
            </div>
          </md-card-content>
        </md-card-content>
        <md-dialog-actions>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-button
              style="margin:5px auto !important"
              class="md-primary btnbutton"
              @click="UpdateConfigurations()"
            >
              Update
            </md-button>
            <md-button
              style="margin:5px auto !important;margin-right: 5px !important;"
              class="btnbutton"
              @click="showDialogEdit = false"
              >Close</md-button
            >
          </div>
        </md-dialog-actions>
      </md-dialog>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  components: {},
  data() {
    return {
      id: null,
      settings: [],
      showDialogEdit: false,
      edit: {},
      active: false,
      isProgress: false
    }
  },
  mounted() {
    this.loadNotifications()
  },
  methods: {
    loadNotifications() {
      let url = process.env.VUE_APP_API_URL + '/settings/index'
      axios
        .get(url, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + this.$store.state.token
          }
        })
        .then(response => {
          this.settings = response.data.settings
        })
        .catch(error => {
          this.notifyVueError(error.response.data.message)
        })
    },

    showDialogEditConfigurations(item) {
      this.id = item.id
      this.edit.name = item.name
      this.edit.value = item.value
      this.edit.type = item.type
      this.active = item.active
      this.showDialogEdit = true
    },

    UpdateConfigurations() {
      this.isProgress = true
      let url = process.env.VUE_APP_API_URL + '/settings/update'
      axios
        .post(
          url,
          {
            id: this.id,
            name: this.edit.name,
            value: this.edit.value,
            type: this.edit.type,
            active: this.active
          },
          {
            headers: {
              Accept: 'application/json',
              Authorization: 'Bearer ' + this.$store.state.token
            }
          }
        )
        .then(response => {
          this.notifyVueSuccess(response.data.message)
          this.loadNotifications()
          this.isProgress = false
        })
        .catch(error => {
          this.notifyVueError(error.response.data.message)
          this.isProgress = false
        })
    },

    validWord(text) {
      let reg = /^[0-9]*\s[a-zA-Z]/
      if (!reg.test(text)) {
        this.notifyVueError('Format not valid, Example: 10 minutes before')
        return false
      } else if (!text.includes('m')) {
      }
    },

    update() {
      $ = function(x) {
        return document.getElementById(x)
      }
      var re = getre($('str').value, $('num').value)
      $('re').innerHTML = 'Numex speaks: <code>' + re + '</code>'
    },

    checkmy() {
      console.log(this.active)
    },

    notifyVueError(text) {
      this.$notify({
        message: '<b>Ups! </b>' + text + '',
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'danger'
      })
    },

    notifyVueSuccess(text) {
      this.$notify({
        message: '<b>Success! </b>' + text + '',
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'success'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio /deep/ .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.form-control-static {
  margin-top: 6px;
}

.mycheck {
  position: absolute !important;
  right: 0px;
  top: 15px;
}

.btnbutton {
  float: right !important;
}
</style>
